import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const StyledWrapper = styled('span')`
	color: #e00b0b;
	font-family: 'Inter Medium', sans-serif;
	font-size: 13px;
	text-align: center;
`;

const ErrorValidationMessage = ({ 'data-test-id': dataTestId = 'error-validation-message', children }) => (
	<StyledWrapper data-test-id={dataTestId}>{children}</StyledWrapper>
);

ErrorValidationMessage.propTypes = {
	children: PropTypes.string.isRequired,
	'data-test-id': PropTypes.string,
};

export { ErrorValidationMessage };
